// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from './application'

import AddressesController from './addresses_controller'
application.register('addresses', AddressesController)

import AdminCashoutsController from './admin_cashouts_controller'
application.register('admin-cashouts', AdminCashoutsController)

import CashoutDrawerController from './cashout_drawer_controller'
application.register('cashout-drawer', CashoutDrawerController)

import AnalyticsController from './analytics_controller'
application.register('analytics', AnalyticsController)

import ArModalController from './ar_modal_controller'
application.register('ar-modal', ArModalController)

import Base3dController from './base_3d_controller'
application.register('base-3d', Base3dController)

import ButtonController from './button_controller'
application.register('button', ButtonController)

import CanvasController from './canvas_controller'
application.register('canvas', CanvasController)

import CartController from './cart_controller'
application.register('cart', CartController)

import ClickController from './click_controller'
application.register('click', ClickController)

import CollectionDropController from './collection_drop_controller'
application.register('collection-drop', CollectionDropController)

import CollectionsController from './collections_controller'
application.register('collections', CollectionsController)

import ConfirmationController from './confirmation_controller'
application.register('confirmation', ConfirmationController)

import CopyController from './copy_controller'
application.register('copy', CopyController)

import CountdownController from './countdown_controller'
application.register('countdown', CountdownController)

import CurationsController from './curations_controller'
application.register('curations', CurationsController)

import DateController from './date_controller'
application.register('date', DateController)

import DateFormatController from './date_format_controller'
application.register('date-format', DateFormatController)

import DefaultBackgroundController from './default_background_controller'
application.register('default-background', DefaultBackgroundController)

import DefaultPrintTypeController from './default_print_type_controller'
application.register('default-print-type', DefaultPrintTypeController)

import DesignController from './design_controller'
application.register('design', DesignController)

import DetailTogglerController from './detail_toggler_controller'
application.register('detail-toggler', DetailTogglerController)

import DiscountsController from './discounts_controller'
application.register('discounts', DiscountsController)

import DomainsController from './domains_controller'
application.register('domains', DomainsController)

import DropController from './drop_controller'
application.register('drop', DropController)

import DropdownController from './dropdown_controller'
application.register('dropdown', DropdownController)

import DropzoneController from './dropzone_controller'
application.register('dropzone', DropzoneController)

import EmitterController from './emitter_controller'
application.register('emitter', EmitterController)

import ExploreController from './explore_controller'
application.register('explore', ExploreController)

import ExploreModalController from './explore_modal_controller'
application.register('explore-modal', ExploreModalController)

import ExploreTopController from './explore_top_controller'
application.register('explore-top', ExploreTopController)

import FadeInController from './fade_in_controller'
application.register('fade-in', FadeInController)

import FillScreenController from './fill_screen_controller'
application.register('fill-screen', FillScreenController)

import FlashController from './flash_controller'
application.register('flash', FlashController)

import FormSubmitterController from './form_submitter_controller'
application.register('form-submitter', FormSubmitterController)

import FrameController from './frame_controller'
application.register('frame', FrameController)

import ImageController from './image_controller'
application.register('image', ImageController)

import ImageDetailsController from './image_details_controller'
application.register('image-details', ImageDetailsController)

import ImageSizesController from './image_sizes_controller'
application.register('image-sizes', ImageSizesController)

import InputValidatorController from './input_validator_controller'
application.register('input-validator', InputValidatorController)

import Internal__CashoutsController from './internal/cashouts_controller'
application.register('internal--cashouts', Internal__CashoutsController)

import Internal__OrdersController from './internal/orders_controller'
application.register('internal--orders', Internal__OrdersController)

import InternalFilesController from './internal_files_controller'
application.register('internal-files', InternalFilesController)

import InternalIssueModalController from './internal_issue_modal_controller'
application.register('internal-issue-modal', InternalIssueModalController)

import InternalNavigationController from './internal_navigation_controller'
application.register('internal-navigation', InternalNavigationController)

import IssuesController from './issues_controller'
application.register('issues', IssuesController)

import IssuesUploadController from './issues_upload_controller'
application.register('issues-upload', IssuesUploadController)

import LikesController from './likes_controller'
application.register('likes', LikesController)

import ListController from './list_controller'
application.register('list', ListController)

import LocationController from './location_controller'
application.register('location', LocationController)

import MasonryController from './masonry_controller'
application.register('masonry', MasonryController)

import MetalController from './metal_controller'
application.register('metal', MetalController)

import MetricController from './metric_controller'
application.register('metric', MetricController)

import MobileProductController from './mobile_product_controller'
application.register('mobile-product', MobileProductController)

import MockupsController from './mockups_controller'
application.register('mockups', MockupsController)

import MockupsV2Controller from './mockups_v2_controller'
application.register('mockups-v2', MockupsV2Controller)

import InfiniteScrollController from './infinite_scroll_controller'
application.register('infinite-scroll', InfiniteScrollController)

import MockupDownloadController from './mockup_download_controller'
application.register('mockup-download', MockupDownloadController)

import ModalController from './modal_controller'
application.register('modal', ModalController)

import NavController from './nav_controller'
application.register('nav', NavController)

import NextPageController from './next_page_controller'
application.register('next-page', NextPageController)

import ObservableController from './observable_controller'
application.register('observable', ObservableController)

import OnLoadController from './on_load_controller'
application.register('on-load', OnLoadController)

import OtherframeController from './otherframe_controller'
application.register('otherframe', OtherframeController)

import ParallaxController from './parallax_controller'
application.register('parallax', ParallaxController)

import PaypalCheckoutController from './paypal_checkout_controller'
application.register('paypal-checkout', PaypalCheckoutController)

import PhoneController from './phone_controller'
application.register('phone', PhoneController)

import PrintPricingController from './print_pricing_controller'
application.register('print-pricing', PrintPricingController)

import PrintPricingMenuOptionsController from './print_pricing_menu_options_controller'
application.register('print-pricing-menu-options', PrintPricingMenuOptionsController)

import PrintSelectorController from './print_selector_controller'
application.register('print-selector', PrintSelectorController)

import ProductController from './product_controller'
application.register('product', ProductController)

import ProductImageController from './product_image_controller'
application.register('product-image', ProductImageController)

import ProductSelectorController from './product_selector_controller'
application.register('product-selector', ProductSelectorController)

import ProductVariantsController from './product_variants_controller'
application.register('product-variants', ProductVariantsController)

import RecaptchaController from './recaptcha_controller'
application.register('recaptcha', RecaptchaController)

import ReorderController from './reorder_controller'
application.register('reorder', ReorderController)

import RightClickController from './right_click_controller'
application.register('right-click', RightClickController)

import ScrollPositionController from './scroll_position_controller'
application.register('scroll-position', ScrollPositionController)

import ShareController from './share_controller'
application.register('share', ShareController)

import SidebarController from './sidebar_controller'
application.register('sidebar', SidebarController)

import SignupController from './signup_controller'
application.register('signup', SignupController)

import SkuKeyController from './sku_key_controller'
application.register('sku-key', SkuKeyController)

import StripeAddressController from './stripe_address_controller'
application.register('stripe-address', StripeAddressController)

import StripeInputController from './stripe_input_controller'
application.register('stripe-input', StripeInputController)

import SupportChatController from './support_chat_controller'
application.register('support-chat', SupportChatController)

import SubmitterController from './submitter_controller'
application.register('submitter', SubmitterController)

import ThreeCanvasController from './three_canvas_controller'
application.register('three-canvas', ThreeCanvasController)

import ThreeFrameController from './three_frame_controller'
application.register('three-frame', ThreeFrameController)

import ThreeMetalController from './three_metal_controller'
application.register('three-metal', ThreeMetalController)

import ThreePrintController from './three_print_controller'
application.register('three-print', ThreePrintController)

import ThumbnailController from './thumbnail_controller'
application.register('thumbnail', ThumbnailController)

import TimezoneController from './timezone_controller'
application.register('timezone', TimezoneController)

import ToggleController from './toggle_controller'
application.register('toggle', ToggleController)

import TooltipController from './tooltip_controller'
application.register('tooltip', TooltipController)

import TopController from './top_controller'
application.register('top', TopController)

import TransitionsController from './transitions_controller'
application.register('transitions', TransitionsController)

import TurboDropdownController from './turbo_dropdown_controller'
application.register('turbo-dropdown', TurboDropdownController)

import UploadProgressController from './upload_progress_controller'
application.register('upload-progress', UploadProgressController)

import UploadsController from './uploads_controller'
application.register('uploads', UploadsController)

import UserMockupsController from './user_mockups_controller'
application.register('user-mockups', UserMockupsController)

import VideoMockupsController from './video_mockups_controller'
application.register('video-mockups', VideoMockupsController)

import SubmitLoadingController from './submit_loading_controller'
application.register('submit-loading', SubmitLoadingController)
